<template>
  <section class="section section__list">
    <div class="section__list-content">
      <Image :source="content.image" class="img__header" />
      <h2 class="mt-30">{{ content.title }}</h2>
      <p class="mt-16 paragraph">{{ content.description }}</p>
      <DynamicLink
        :button="content.button"
        :link="link"
        :page="page"
        :route="route"
        class="mt-30"
      />
    </div>
    <div class="bg__light section__list-list">
      <h3 class="h3">{{ content[list].title }}</h3>
      <ul class="mt-30">
        <li class="list" v-for="el in content[list].items" :key="el.flexKey">
          <Icon class="list__icon" id="arrow" />
          <span class="list__element">{{ el.text }}</span>
        </li>
      </ul>
      <p v-if="content[list].description" class="paragraph mt-30">
        {{ content[list].description }}
      </p>
      <p v-if="content[list].notice" class="paragraph bg__dark mt-30">{{ content[list].notice }}</p>
    </div>
  </section>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'
import DynamicLink from '@/components/small/DynamicLink.vue'

export default {
  name: 'ListSection',
  components: { DynamicLink, Icon, Image },
  props: {
    button: {
      type: Object,
      dfeault: null,
    },
    content: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
    list: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      default: '',
    },
    route: {
      type: Object,
      default: null,
    },
  },
}
</script>
